import React from 'react';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import './AccountMixSummaryModule.scss';
import classnames from 'classnames';
import { Image } from 'components/Image/Image';

const ColumnAccountMix = props => {
  const { total, description, className } = props;

  const columnClass = classnames(
    'flex-column items-align-center flex-basis-50',
    className,
  );

  return (
    <FlexContainer className={columnClass}>
      <Label type="HeadingBold">{total}</Label>
      <Label type="Subtitle-2">{description}</Label>
    </FlexContainer>
  );
};

const CreditFactor = props => {
  const { image, title, value } = props;
  const blockClass = classnames({
    'Gray system_neutral_n250_text': value === 0,
  });

  return (
    <FlexContainer
      className={'width100 justify-between padLR20 m-padL14 items-align-center'}
    >
      <FlexContainer className={'items-align-center'}>
        <FlexContainer className={'padR8'}>
          <Image imgClass={'accountMix' + image + blockClass} />
        </FlexContainer>
        <FlexContainer>
          <Label className={blockClass} type={'Subtitle-3 mCaption'}>
            {title}
          </Label>
        </FlexContainer>
      </FlexContainer>
      <Label className={blockClass} type={'Subtitle-3 mCaption'}>
        {value}
      </Label>
    </FlexContainer>
  );
};

const AccountMixSummaryColumn = props => {
  const { countAccounts, countAccTypes, columnLeft, columnRight } = props;

  return (
    <FlexContainer className={'flex-column gap-16 padB24'}>
      <FlexContainer className={'width100 justify-between'}>
        <ColumnAccountMix
          className={'separator'}
          total={countAccounts}
          description={'Accounts'}
        />
        <ColumnAccountMix total={countAccTypes} description={'Account Types'} />
      </FlexContainer>
      <FlexContainer>
        <FlexContainer className={'flex-basis-50 flex-column gap-12'}>
          {columnLeft.map((column, index) => {
            return (
              <CreditFactor
                key={'columnAccountMix' + index}
                title={column?.title}
                value={column?.value}
                image={column?.img}
              />
            );
          })}
        </FlexContainer>
        <FlexContainer className={'flex-basis-50 flex-column gap-12'}>
          {columnRight.map((column, index) => {
            return (
              <CreditFactor
                key={'columnAccountMix' + index}
                title={column?.title}
                value={column?.value}
                image={column?.img}
              />
            );
          })}
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default AccountMixSummaryColumn;
